import type { BoggleBadgeId } from './types'

/** Flat badge ids evaluated via per-id checks (not tier families). */
export const BOGGLE_NON_TIERED_BADGE_IDS = [
  'cornered',
  'doubleDouble',
  'explorer',
  'isogram',
  'longStart',
  'luckyCharm',
  'master',
  'sorcerer',
  'palindrome',
  'spellingBee',
  'square',
  'straight',
  'straightForward',
  'strongStart',
  'tartarSauce',
  'verbose',
] as const satisfies readonly BoggleBadgeId[]
